import { keyframes } from 'tss-react'
import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  container: {
    padding: `${theme.spacing(2)} !important`,
    height: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    animation: `${keyframes`
      from {
        transform: scale(0);
      }
      to {
        transform: scale(1);
      }
    `} 0.5s cubic-bezier(0.7, 0, 0, 1)`,
    animationDelay: '0.6s',
    '&:nth-of-type(1)': {
      animationDelay: '0s',
    },
    '&:nth-of-type(2)': {
      animationDelay: '0.1s',
    },
    '&:nth-of-type(3)': {
      animationDelay: '0.2s',
    },
    '&:nth-of-type(4)': {
      animationDelay: '0.3s',
    },
    '&:nth-of-type(5)': {
      animationDelay: '0.4s',
    },
    '&:nth-of-type(6)': {
      animationDelay: '0.5s',
    },
    [theme.breakpoints.down('md')]: {
      padding: `${theme.spacing(4)} !important`,
    },
  },
  content: {
    width: '100%',
    paddingBottom: theme.spacing(7),
    position: 'relative',
  },
  name: {
    padding: 0,
    marginBottom: theme.spacing(4),
  },
  category: {
    marginBottom: theme.spacing(4),
    color: 'rgba(0, 0, 0, 0.5)',
    textTransform: 'uppercase',
  },
  description: {
    lineHeight: '1.55em',
    marginBottom: theme.spacing(4),
    color: 'rgba(0, 0, 0, 0.7)',
  },
  actions: {
    marginTop: 'auto',
    display: 'flex',
  },
}))
